module.exports = __webpack_public_path__ + "static/media/logo_white.7c5c63d4.png";